import { useLocation } from "react-router-dom";
import TabsComponent from "./TabsComponent"

const Dashboard = () => {
  const { search } = useLocation();
  const query = new URLSearchParams(search);

  const currentTab = query.get("tab") || "analytics"; // Default to 'map' if no tab is specified
  return (
	<div>
    {currentTab}
		<TabsComponent currentTab = {currentTab}/>
	</div>
  )
}

export default Dashboard